module.exports = __webpack_public_path__ + "assets/media/segment-logo-with-title.07b2cb6e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingInstallStep/SegmentInstall/segment-logo-with-title.svg
// module id = 2908
// module chunks = 0